angular.module('Itao.IndicatorMap').directive('indicatorRadioGroup', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorRadioGroup.html',
    restrict: 'E',
    scope: {
      indicators: '=',
      indicatorSets: '=',
      selectedIndicator: '=',
      onIndicatorSelect: '&',
      deselectAllIndicators: "&"
    },
    link: function (scope) {

      scope.openDropdown = function () {
        jQuery('#indicatorDropdown').closest('.dropdown').toggleClass('open');
      };

      scope.indicatorsToArray = function() {
        var indicatorsArray = [];
        angular.forEach(scope.indicators, function(val, key) {
          indicatorsArray.push(val);
        });
        return indicatorsArray.sort(function(a,b) {
          var sortingValueA = 0;
          var sortingValueB = 0;

          if(a.isDefault && scope.indicatorSets != null) {
            sortingValueA = getIndicatorSetSortingByDefaultIndicatorUid(a.uid);
          } else {
            sortingValueA = a.sorting;
          }

          if(b.isDefault && scope.indicatorSets != null) {
            sortingValueB = getIndicatorSetSortingByDefaultIndicatorUid(b.uid);
          } else {
            sortingValueB = b.sorting;
          }

          return sortingValueA - sortingValueB;
        });
      };

      function getIndicatorSetSortingByDefaultIndicatorUid(uid) {
        var indicatorSetSorting = 0;
        scope.indicatorSets.forEach(function(indicatorSet){
          if(indicatorSet.defaultIndicator.uid === uid) {
            indicatorSetSorting = indicatorSet.sorting;
          }
        });
        return indicatorSetSorting;
      }

      scope.selectIndicator = function (indicator) {
        if(!indicator) return;
        scope.deselectAllIndicators();
        scope.onIndicatorSelect({indicator: indicator});
        scope.selectedIndicator = indicator;
      };
    }
  };
});
